import { REWARDS_WIDGET_NAMES } from "@/constants/widget-names";
import { RewardsVerifyAccountModalWidgetDefinition } from "@apps/rewards/constants/definitions";
import type { RewardsWidgetInjectorConfig } from "@apps/rewards/types";
import WidgetInjectedSdkEvent from "@modules/sdk/common_sdk/events/WidgetInjectedSdkEvent";
import { dispatchSdkEvent } from "@modules/sdk/helpers";

class RewardsVerifyAccountModalWidgetInjector {
    constructor(private readonly config: RewardsWidgetInjectorConfig) {}

    start(): void {
        this.config.logger.debug(
            "RewardsVerifyAccountModalWidgetInjector start",
            {
                placeholderSelector: this.config.placeholderSelector,
            }
        );

        const widgetName =
            REWARDS_WIDGET_NAMES.REWARDS_VERIFY_ACCOUNT_MODAL_WIDGET;

        const targets$ = this.config.mutationObserverInjector.register({
            targetSelector: this.config.placeholderSelector,
        });

        targets$.subscribe((placeholder) => {
            this.config.logger?.debug(
                "RewardsVerifyAccountModalWidgetInjector found placeholder",
                {
                    placeholder,
                }
            );

            void (async () => {
                const RewardsVerifyAccountModalWidget =
                    await this.config.dynamicImportManager.importDefault(
                        RewardsVerifyAccountModalWidgetDefinition
                    );

                const widget = new RewardsVerifyAccountModalWidget(
                    {
                        target: placeholder,
                    },
                    this.config.logger
                );

                widget.init();

                this.config.eventsCollector.pushEvent(
                    this.config.eventsFactory.createWidgetInjected(widgetName)
                );

                dispatchSdkEvent(new WidgetInjectedSdkEvent(widgetName));
            })();
        });
    }
}

export default RewardsVerifyAccountModalWidgetInjector;
